/**
 * Event types that are noise and should be hidden from display.
 * Their information is either redundant or integrated into other events.
 */
export const HIDDEN_EVENT_TYPES = new Set([
  "step:start", // Step number integrated into tool events
  "step:end", // Redundant
  "tool:start", // Redundant - specific events (file:edit, etc.) shown instead
  "tool:end", // Redundant
  "phase:status", // Noisy - phase:transition is sufficient
  "phase:system-prompt", // Noisy - only used for inspection modal
  "usage:update", // Noisy - model info shown in header
]);

/**
 * Event types to exclude during hydration to preserve more displayable events.
 * Note: keep step:start and phase:status because the UI derives
 * step numbers and phase header state from them.
 */
export const HYDRATION_EXCLUDE_EVENT_TYPES = [
  "step:end",
  "tool:start",
  "tool:end",
];
